import { useUser } from "@customer-tools-web/component-authentication";
import * as Cookies from "js-cookie";

export const LOGIN_AS_AGENT_COOKIE_KEY = "x-impersonate-userid";

export const useLoginAsAgent = () => {
  const {
    permissions: { isLoginAsAgent },
    email,
  } = useUser();

  const login = (id: string) => {
    Cookies.set(LOGIN_AS_AGENT_COOKIE_KEY, id, { path: "/" });
    window.location.href = "/pro/listings";
  };

  const logout = () => {
    Cookies.remove(LOGIN_AS_AGENT_COOKIE_KEY);
    window.location.href = "/users";
  };

  return {
    isLoginAsAgent,
    info: {
      email,
    },
    login,
    logout,
  };
};
